import { render, staticRenderFns } from "./Mp.vue?vue&type=template&id=7b30864d&"
import script from "./Mp.vue?vue&type=script&lang=js&"
export * from "./Mp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports